import WidgetLayout from '@/admin/js/layout/WidgetLayout.vue';

const widgetRoutes = {
  name: 'widget',
  path: '/widget',
  component: WidgetLayout,
  meta: { title: 'Виджет', noCache: true, public: true },
  redirect: '/widget/start',
  children: [
    {
      path: 'start',
      component: () => import('@/admin/js/views/widget/QuickStartWidget.vue'),
      name: 'WidgetQuickStart',
      meta: {
        title: 'Быстрый старт',
        noCache: true,
        embed: true,
        public: true 
      },
    },
  ],
};

export default widgetRoutes;
